import { useLayoutEffect } from 'react';

import { FullPageLoaderInput, useAppStore } from 'state_management/zustand/appStore';

type UseFullPageLoaderArgs = FullPageLoaderInput & {
  show: boolean;
};

export function useFullPageLoader({
  //
  id,
  show,
  message,
  priority,
  scope,
  autoId,
  enterDelay,
  exitDelay
}: UseFullPageLoaderArgs): void {
  const showFullPageLoader = useAppStore((state) => state.showFullPageLoader);
  const hideFullPageLoader = useAppStore((state) => state.hideFullPageLoader);

  useLayoutEffect(() => {
    return () => {
      hideFullPageLoader(id);
    };
  }, [hideFullPageLoader, id]);

  useLayoutEffect(() => {
    if (show) {
      showFullPageLoader({
        id,
        message,
        priority,
        scope,
        autoId,
        enterDelay,
        exitDelay
      });
    } else {
      hideFullPageLoader(id);
    }
  }, [autoId, enterDelay, exitDelay, hideFullPageLoader, id, message, priority, scope, show, showFullPageLoader]);
}
